export default {
  error: {
    internal_error: 'Une erreur interne s\'est produite',
  },
  user: {
    remove_associated_account: {
      success: 'Vous venez de dissocier %provider% de votre compte.',
      need_password: 'Veuillez d\'abord définir un mot de passe si vous souhaitez retirer %provider%.',
    },
    update_info: {
      success: 'Vos informations ont bien été mis à jour !',
      error: 'Une erreur est survenue !'
    },
    change_pass: {
      success: 'Votre mot de passe a bien été modifié !',
      error: 'L\'ancien mot de passe ne correspond pas !'
    }
  },
  offer: {
    add: 'Votre annonce a bien été ajouté, elle sera publié après modération.',
    delete: {
      title: 'Etes-vous sûr de supprimer votre annonce ?',
      description: 'Cette action est irréversible',
      reasonsOptions: {
        'sold': 'Je l\'ai vendue sur Escrime-Occasion',
        'sold2': 'Je l\'ai vendue par un autre moyen',
        'just_delete': 'Je ne souhaite plus vendre ce matériel',
        'other': 'Autre motif',
      },
      errorReason: 'Veuillez indiquer un motif',
      btnConfirm: 'Confirmer la suppression',
      btnCancel: 'Annuler',
      success: {
        title: 'Supprimé !',
        description: 'Votre annonce a bien été supprimé'
      },
      error: {
        title: 'Erreur !',
        description: 'Impossible de supprimer votre annonce'
      }
    },
    importLeboncoin: {
      title: 'Préremplir mon annonce depuis leboncoin',
      description: 'Veuillez rentrer l\'url de votre annonce leboncoin :',
      invalidUrl: 'L\'url est invalide !',
      confirm: 'Importer',
      success: {
        title: 'Réussi !',
        description: 'Votre annonce a été partiellement rempli à l\'aide de votre annonce leboncoin ! (Titre, description, prix, état, armes, localisation et images)'
      },
      error: {
        title: 'Erreur',
        description: 'Impossible d\'importer votre annonce depuis leboncoin. Veuillez ressayer. Si le problème persiste n\'hésitez pas à nous contacter.'
      }
    }
  },
  contact: {
    success: 'Nous avons bien reçu votre message ! Nous vous répondrons au plus vite.',
    error: 'Le message n\'a pas pu être envoyé !'
  },
  contest: {
    minLot: 'Veuillez sélectionner au moins 1 lot',
    loadError: 'Impossible de charger le formulaire d\'inscription',
    successRegister: 'Vous êtes bien inscrit !',
    errorRegister: 'Nous n\'avons pas pu vous inscrire ...',
    successUnregister: 'Vous êtes bien désinscrit !',
    errorUnregister: 'Nous n\'avons pas pu vous désinscrire ...'
  },
  options: {
    up: {
      title: 'Premiers résultats',
      description: 'Cette option met votre annonce en avant en la republiant automatiquement chaque jour en haut de la page d’annonce, avec les premiers résultats. Votre visibilité auprès des acheteurs est assurée !',
      img: null
    },
    front_page: {
      title: 'Annonce à la Une',
      description: 'Votre annonce apparaîtra parmi les annonces “à la une”, directement sur la page d’accueil du site. Elle sera donc visible par tous les utilisateurs ! Elle apparaîtra aussi avec la page des annonces où elle se démarquera par un Design différent des autres annonces.',
      img: null
    }
  },
  payment: {
    success: 'Votre paiement a été validé !'
  },
  blocking: {
    title: 'Voulez-vous bloquer l\'utilisateur %username% ?',
    success: {
      title: 'Utilisateur bloqué',
      message: 'Vous avez bloqué %username%'
    },
    error: {
      title: 'Erreur !',
      message: 'Impossible de bloquer l\'utilisateur'
    },
    button: {
      confirm: 'Oui, bloquer',
      cancel: 'Annuler'
    },
    action: 'Bloquer l\'utilisateur',
    status: {
      blocked: 'Cet utilisateur vous a bloqué',
      blocking: 'Vous avez bloqué l\'utilisateur'
    }
  },
  unblocking: {
    title: 'Voulez-vous débloquer l\'utilisateur %username% ?',
    success: {
      title: 'Utilisateur débloqué',
      message: 'Vous pouvez à nouveau échanger avec %username%',
    },
    error: {
      title: 'Erreur !',
      message: 'Impossible de débloquer l\'utilisateur'
    },
    button: {
      confirm: 'Débloquer',
      cancel: 'Annuler'
    },
    action: 'Débloquer l\'utilisateur'
  },
  conversation: {
    textarea: 'Ecrivez votre message ...',
    warningAlert: 'Veuillez privilégier vos échanges par cette messagerie afin de ne pas divulguer vos informations personnelles (email, téléphone, etc.)',
    waitBeforeSending: 'Veuillez patienter avant d\'envoyer un nouveau message.',
    failedToSendMsg: 'Impossible d\'envoyer votre message !'
  },
  deleteConversation: {
    title: 'Voulez-vous archiver la conversation ?',
    button: {
      confirm: 'Oui, archiver',
      cancel: 'Annuler',
    },
    success: {
      title: 'Conversation archivé !',
      message: 'Vous avez archivé cette conversation'
    },
    error: {
      title: 'Erreur !',
      message: 'Impossible d\'archiver la conversation'
    }
  }
}
